<video [id]="'fileVideo' + index" [width]="width" [height]="height" class="file-video" [controls]="controls">
  <source [src]="path | SafeUrl" />
</video>
